import { Helmet } from "react-helmet-async";
import {
  SITE_NAME,
  OG_IMAGE,
  THEME_COLOR,
  formatPageTitle,
  getCanonicalPath,
} from "../lib/seo";

const SEO = ({
  title,
  description,
  keywords,
  path = "/",
  ogType = "website",
  noindex = false,
  jsonLd,
}) => {
  const pageTitle = formatPageTitle(title);
  const canonical = getCanonicalPath(path);
  const robots = noindex ? "noindex, nofollow" : "index, follow";

  const schemas = Array.isArray(jsonLd) ? jsonLd : jsonLd ? [jsonLd] : [];

  return (
    <Helmet>
      <title>{pageTitle}</title>
      <meta name="description" content={description} />
      {keywords && <meta name="keywords" content={keywords} />}
      <meta name="robots" content={robots} />
      <link rel="canonical" href={canonical} />

      <meta property="og:title" content={pageTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={OG_IMAGE} />
      <meta property="og:url" content={canonical} />
      <meta property="og:type" content={ogType} />
      <meta property="og:site_name" content={SITE_NAME} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={pageTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={OG_IMAGE} />

      <meta name="theme-color" content={THEME_COLOR} />

      {schemas.map((schema, i) => (
        <script key={i} type="application/ld+json">
          {JSON.stringify(schema)}
        </script>
      ))}
    </Helmet>
  );
};

export default SEO;
